import React from 'react';
import { ScrollText } from 'lucide-react';

const missions = [
    {
        text: "To lead souls to Christ, to demonstrate the standard of Christian living, and to spread the Gospel of Jesus Christ.",
        verse: "Matt 28:19-20",
    },
    {
        text: "To advance the spiritual growth of members by strengthening our Christian faith formation through biblical teachings, prayers, and exercising our different spiritual gifts.",
        verse: "Acts 2:42-47",
    },
    {
        text: "To think, act, and be like Jesus, fully surrendered to Him as Lord, placing Jesus at the center of our homes, and partnering with other Christian groups to transform our Nation through the love of Christ.",
        verse: "Matt 25:31-46, Mark 10:7-9",
    },
    {
        text: "To continue to promote peaceful and cordial relationships with other Dioceses to ensure the success of our common commitment.",
        verse: "John 13:35, John 17:21",
    },
    {
        text: "To provide basic health care and wellness facilities in our area of influence, including diagnostic medical laboratories and mobile clinics to reach the rural areas of our Diocese.",
        verse: "3 John 1:2",
    },
    {
        text: "To promote a vibrant, dynamic, and committed Youth Forum capable of running with the vision of our Diocese.",
        verse: "Habakkuk 2:2-3",
    },
];

const MissionStatement = () => {
    return (
        <section
            className="bg-white py-16 px-4 border rounded-lg shadow-lg max-w-5xl mx-auto mb-12"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
        >
            <div className="text-center mb-8">
                <h2
                    className="text-3xl md:text-4xl font-bold text-red-600"
                    data-aos="fade-up"
                >
                    <ScrollText className="inline-block w-8 h-8 mr-2 text-red-500" />
                    Mission Statement
                </h2>
                <hr
                    className="w-24 border-t-2 border-red-500 mx-auto mt-2"
                    data-aos="fade-up-right"
                />
            </div>

            <div className="space-y-6 text-gray-800 text-[1.1rem] leading-relaxed">
                {missions.map((mission, index) => (
                    <div
                        key={index}
                        className="flex flex-col"
                        data-aos="fade-down"
                        data-aos-delay={200}
                    >
                        <p className="font-semibold">{mission.text}</p>
                        <span className="text-sm text-gray-500 mt-1 italic">
                            ({mission.verse})
                        </span>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default MissionStatement;
